import { FatorEcg, HistoricoTranche, SIGLA_PORTE_BENEFICIARIO, VigenciaFatorEcg, EventoDistribuicao, FatorReducaoEcg, LabelSiglaPorte, SiglaPorte, LimiteContratacaoOperacao, PorteEmpresaClienteTrancheDTO } from './../../../model/tranche.model';
import { LabelTipoCalculoLimite, TIPO_CALCULO_LIMITE, Tranche} from 'src/app/model/tranche.model';
import { TrancheService } from 'src/app/shared/services/tranche.service';
import { Component, Injector, OnDestroy, TemplateRef, ViewChild} from "@angular/core";
import { BaseEntityComponent, BnLoadingService, EntityPagedRequestParameters, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { CanComponentDeactivate } from 'src/app/core/can-deactivate-guard.service';
import {Validators, UntypedFormGroup } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { OcorrenciaValidacaoVO } from 'src/app/shared/ocorrencia-validacao.vo';
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { BnUsuarioService, Usuario } from "@bndes/bndes-ux4/bn-usuario";
import { ActivatedRoute } from '@angular/router';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { RemoverAlertasService } from 'src/app/shared/services/remover-alertas.service';
import { ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { mergeMap, map, takeUntil } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';
import moment from "moment";
import { AmbienteService } from 'src/app/shared/services/ambiente-service';
import { NgbModal, NgbModalOptions, NgbModalRef, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { MensagemService } from '../../mensagem.service';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { AgenteFinanceiroService } from 'src/app/shared/services/agente-financeiro.service';
import { ModalFatorEcgComponent } from '../modal-fator-ecg/modal-fator-ecg.component';
import { DatePipe } from '@angular/common';
import { ModalConfirmaFatorEcgComponent } from '../modal-confirma-fator-ecg/modal-confirma-fator-ecg';
import { ModalidadeService } from 'src/app/shared/services/modalidade.service';
import { MODALIDADE_GARANTIA_FGBS } from 'src/app/model/modalidade_garantia.model';
import { DataSistemaService } from 'src/app/shared/services/data-sistema.service';
import { Modalidade } from 'src/app/model/dominio-operacao.model';

@Component({
    selector: 'app-tranches-cadastro',
    templateUrl: './tranches-cadastro.component.html',
    styleUrls: ['./tranches-cadastro.componet.scss'],
    standalone: false
})
export class TranchesCadastroComponent
        extends BaseEntityComponent<Tranche> implements CanComponentDeactivate, OnDestroy {

    private readonly destroy$ = new Subject();
    formTranche:UntypedFormGroup = null;
    formFatorRedutor:UntypedFormGroup = null;
    formTaxaStopLoss:UntypedFormGroup = null;
    formLimiteContratacaoBeneficiario:UntypedFormGroup = null;
    formLimiteContratacaoOperacao:UntypedFormGroup = null;
    formPrazoContratacao:UntypedFormGroup = null;
    formNovaVigenciaFatorEcg:UntypedFormGroup = null;
    formVigenciaFatorEcg:UntypedFormGroup = null;
    //formFatorEcg:UntypedFormGroup = null; talvez exclua
    formEventoDistribuicao: UntypedFormGroup = null;
    formNovoFatorRedutorEcg:UntypedFormGroup = null;
    formEncerrarFatorRedutorEcg:UntypedFormGroup = null;
    formEncerrarLimiteContratacaoOperacao:UntypedFormGroup = null;
    formPorteBeneficario:UntypedFormGroup = null;
    formEncerrarPorteBeneficiario:UntypedFormGroup = null;

    private ocorrencias:OcorrenciaValidacaoVO[] = [];
    private usuarioLogado:Usuario;

    private vc: BnConfirmDirective;
    private permissaoEdicao: Boolean;
    private permissaoSalvar: boolean = false; // criado para a modal de VigenciaFatorEcg para auxiliar na verificação de mudança da modal
    private permissaoEditar: boolean = false
    private encerrarFator: boolean = false
    public labels = LabelTipoCalculoLimite;
    private opcoesEdicaoTipoCalculoLimite = TIPO_CALCULO_LIMITE;
    public tranches: Tranche;
    public mostraAbas: boolean = true;
    public mostraAbaPrazosContratacao: boolean = true;
    public mostraAbaLimiteOperacao: boolean = true;
    public exibeAbaFatorK: boolean = true;
    public exibeAbaEventosDistribuicao: boolean = false;
    public historico: HistoricoTranche[];
    public pesquisado: boolean = false;
    public siglasPorteBeneficiario = [];
    public ambientePrd$: Observable<boolean>
    public abaAtiva: string = 'dados-basicos';
    public atributosPaginacao: EntityPagedRequestParameters;
    public opcoesPaginacao: number[];
    public listaHistoricos: any[];
    public countHistoricos: number;
    public dataAtual: Date = new Date();
    public dataAmanha: Date = new Date();
    public dataAtualFormatada: string;
    public dataFimDaTranche: Date; //criada para comparar com a data atual
    private idExclusao: number;
    private dataInicioValidade: Date;
    private dataFimValidade: Date;
    private idDuplicacao: number;
    objetivoFinanciamentoSelect: any;
    siglaPorte: any;
    dataReferenciaDefault: Date;
    dataInicioMinimoCadastroLimiteOperacao: Date;

    public vigenciasFatorEcg: VigenciaFatorEcg[];
    public fatoresReducaoEcg: FatorReducaoEcg[];
    public vigenciaFatorEcg: VigenciaFatorEcg = null;
    public fatorEcgEdicao: FatorEcg = null;
    public ehCadastroVigencia: boolean = false;
    public fatorEncerramento: FatorReducaoEcg;

    public numeroCestaMaximo : number;
    public eventosDistribuicao: EventoDistribuicao[];
    public agentesFinanceirosHabilitados: AgenteFinanceiro[];

    public porteBeneficiario: PorteEmpresaClienteTrancheDTO[];
    public verPortesDesativados: boolean = false;

    public listaCiclosMetaDescumprida = [];
    private modalRefCiclosMetaDescumprida: NgbModalRef;


    @ViewChild('botoesFatorRedutor') botoesPersonalizadosFatorRedutor: TemplateRef<any>;
    @ViewChild('bodyFatorRedutor') msgPersonalizadaFatorRedutor: TemplateRef<any>;
    @ViewChild('botoesTaxaStopLoss') botoesPersonalizadosTaxaStopLoss: TemplateRef<any>;
    @ViewChild('bodyTaxaStopLoss') msgPersonalizadaTaxaStopLoss: TemplateRef<any>;
    @ViewChild('botoesLimiteContratacaoBeneficiario') botoesPersonalizadosLimiteContratacaoBeneficiario: TemplateRef<any>;
    @ViewChild('bodyLimiteContratacaoBeneficiario') msgPersonalizadaLimiteContratacaoBeneficiario: TemplateRef<any>;
    @ViewChild('botoesLimiteContratacaoOperacao') botoesPersonalizadosLimiteContratacaoOperacao: TemplateRef<any>;
    @ViewChild('bodyLimiteContratacaoOperacao') msgPersonalizadaLimiteContratacaoOperacao: TemplateRef<any>;
    @ViewChild('botoesPrazoContratacao') botoesPersonalizadosPrazoContratacao: TemplateRef<any>;
    @ViewChild('bodyPrazoContratacao') msgPersonalizadaPrazoContratacao: TemplateRef<any>;
    @ViewChild('botoesNovaVigenciaFatorEcg') botoesNovaVigenciaFatorEcg: TemplateRef<any>;
    @ViewChild('bodyNovaVigenciaFatorEcg') msgNovaVigenciaFatorEcg: TemplateRef<any>;
    @ViewChild('botoesNovoFatorRedutorEcg') botoesNovoFatorRedutorEcg: TemplateRef<any>;
    @ViewChild('bodyNovoFatorRedutorEcg') msgNovoFatorRedutorEcg: TemplateRef<any>;
    @ViewChild('botoesDuplicaVigenciaFatorEcg') botoesDuplicaVigenciaFatorEcg: TemplateRef<any>;
    @ViewChild('bodyDuplicaVigenciaFatorEcg') msgDuplicaVigenciaFatorEcg: TemplateRef<any>;
    @ViewChild('botoesVigenciaFatorEcg') botoesVigenciaFatorEcg: TemplateRef<any>;
    @ViewChild('bodyVigenciaFatorEcg') msgVigenciaFatorEcg: TemplateRef<any>;
    //@ViewChild('botoesFatorEcg') botoesFatorEcg: TemplateRef<any>; talvez exclua
    //@ViewChild('bodyFatorEcg') msgFatorEcg: TemplateRef<any>; talvez exclua
    @ViewChild('botoesEventoDistribuicao') botoesPersonalizadosEventoDistribuicao: TemplateRef<any>;
    @ViewChild('bodyEventoDistribuicao') msgPersonalizadaEventoDistribuicao: TemplateRef<any>;

    @ViewChild('msgTemplateExcluir') msgTemplateExcluir: TemplateRef<any>;
    @ViewChild('botoesPersonalizadosExcluir') botoesPersonalizadosExcluir: TemplateRef<any>;

    @ViewChild('msgTemplateExcluirLimiteContratacaoOperacao') msgTemplateExcluirLimiteContratacaoOperacao: TemplateRef<any>;
    @ViewChild('botoesPersonalizadosExcluirLimiteContratacaoOperacao') botoesPersonalizadosExcluirLimiteContratacaoOperacao: TemplateRef<any>;

    @ViewChild('msgTemplateEncerrarLimiteContratacaoOperacao') msgTemplateEncerrarLimiteContratacaoOperacao: TemplateRef<any>;
    @ViewChild('botoesPersonalizadosEncerrarLimiteContratacaoOperacao') botoesPersonalizadosEncerrarLimiteContratacaoOperacao: TemplateRef<any>;


    @ViewChild('msgTemplateExcluirFatorRedutor') msgTemplateExcluirFatorRedutor: TemplateRef<any>;
    @ViewChild('botoesExcluirFatorRedutor') botoesExcluirFatorRedutor: TemplateRef<any>;

    @ViewChild('msgTemplateEncerrarFatorRedutor') msgTemplateEncerrarFatorRedutor: TemplateRef<any>;
    @ViewChild('botoesEncerrarFatorRedutor') botoesEncerrarFatorRedutor: TemplateRef<any>;

    @ViewChild('msgTemplatePorteBeneficiario') msgTemplatePorteBeneficiario: TemplateRef<any>;
    @ViewChild('botoesPorteBeneficiario') botoesPorteBeneficiario: TemplateRef<any>;

    @ViewChild('msgTemplateExcluirPorteBeneficiario') msgTemplateExcluirPorteBeneficiario: TemplateRef<any>;
    @ViewChild('botoesPersonalizadosExcluirPorteBeneficiario') botoesPersonalizadosExcluirPorteBeneficiario: TemplateRef<any>;

    @ViewChild('msgTemplateEncerrarPorteBeneficiario') msgTemplateEncerrarPorteBeneficiario: TemplateRef<any>;
    @ViewChild('botoesPersonalizadosEncerrarPorteBeneficiario') botoesPersonalizadosEncerrarPorteBeneficiario: TemplateRef<any>;

    @ViewChild('modalCiclosMetaDescumprida', { static: false}) modalCiclosMetaDescumprida: TemplateRef<any>;

    constructor(
        private datePipe : DatePipe,
        private abrirModal: NgbModal,
        private activatedRoute:ActivatedRoute,
        private modalService: BnModalMessageService,
        private permissaoService: PermissaoService,
        protected injector: Injector,
        private usuarioService: BnUsuarioService,
        private tranchesService: TrancheService,
        private removerAlertasService: RemoverAlertasService,
        private loadingService: BnLoadingService,
        private ambienteService: AmbienteService,
        private mensagemService: MensagemService,
        private agenteFinanceiroService: AgenteFinanceiroService,
        private modalidadeService: ModalidadeService,
        private dataSistemaService: DataSistemaService) {
          super(tranchesService);
          this.config.rotaLista = "tranches/pesquisa";
          this.config.bloquearTelaAoRecuperarModelo = true;
          this.permissaoEdicao = false;
          this.dataAmanha = moment(this.dataAmanha).add(1, 'days').toDate();
        }

    ngOnInit(){
        this.ambientePrd$ = this.ambienteService.isPRD();
        this.formTranche = this.createReactiveForm();
        this.tranchesService.buscarNumeroCestaMax().subscribe((data) => {
          this.numeroCestaMaximo = parseInt(data);
          this.formTranche.get('numeroTranche').patchValue(this.numeroCestaMaximo+1); //Defino o numeroCesta permitido para cadastrar
        });

        this.dataAtualFormatada = this.datePipe.transform(this.dataAtual, 'yyyy-MM-dd');
        this.buscarAgentesFinanceiros();
        this.formFatorRedutor = this.createReactiveFormFatorRedutor();
        this.formTaxaStopLoss = this.createReactiveFormTaxaStopLoss();
        this.formLimiteContratacaoBeneficiario = this.createReactiveFormLimiteContratacaoBeneficiario();
        this.formLimiteContratacaoOperacao = this.createReactiveFormLimiteContratacaoOperacao();
        this.modalidadeService.modalidade$.pipe(takeUntil(this.destroy$))
          .subscribe((modalidade: string) => {
            if (modalidade === MODALIDADE_GARANTIA_FGBS) {
              this.siglasPorteBeneficiario = SIGLA_PORTE_BENEFICIARIO;
            } else {
              this.siglasPorteBeneficiario = SIGLA_PORTE_BENEFICIARIO.filter(s => s.sigla != 'MEI');
            }
            this.formPrazoContratacao = this.createReactiveFormPrazoContratacao(modalidade);
          });
        this.formNovaVigenciaFatorEcg = this.createReactiveFormNovaVigenciaFatorEcg();
        this.formVigenciaFatorEcg = this.createReactiveFormVigenciaFatorEcg();
        //this.formFatorEcg = this.createReactiveFormFatorEcg(); talvez exclua
        this.formEventoDistribuicao = this.createReactiveFormEventoDistribuicao();
        this.formNovoFatorRedutorEcg = this.createReactiveFormNovoFatorRedutorEcg();
        this.formEncerrarFatorRedutorEcg = this.createReactiveFormEncerrarFatorRedutorEcg();
        this.formEncerrarLimiteContratacaoOperacao = this.createReactiveFormEncerrarLimiteContratacaoOperacao();
        this.formPorteBeneficario = this.createReactiveFormPorteBeneficario();
        this.formEncerrarPorteBeneficiario = this.createReactiveFormEncerrarPorteBeneficiario();
        this.usuarioService.usuario$.subscribe(usuario => this.usuarioLogado = usuario);
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe(resp => {
            this.permissaoEdicao = resp[ROLE_GESTOR_ENVIO];
                this.preparaModelo().subscribe((tranche) => {
                  this.preencheForm(tranche);
                    this.setModel(tranche);
                    this.exibeAbaFatorK = tranche.temFatorKParaCalculoEcg;
                    this.exibeAbaEventosDistribuicao = tranche.siglaModalidadeGarantia === "PEAC" && tranche.numeroTranche == 2;
                    this.mostraAbaPrazosContratacao = tranche.siglaModalidadeGarantia !== "FGT";
                    this.mostraAbaLimiteOperacao = tranche.siglaModalidadeGarantia === "FGBS";
                    this.ordenarFatoresRedutores(tranche.fatoresRedutores);
                    console.log("model: "+ JSON.stringify(this.model))
                    this.opcoesPaginacao = [10, 5];
                    this.atributosPaginacao = {
                      page: 1,
                      pageSize: this.opcoesPaginacao[1]
                    };
                    this.pesquisar(this.atributosPaginacao);
                });
        });
        this.desabilitaCheckbox();
        this.objetivoFinanciamentoSelect = [
          {label: 'G - Giro', value: 'G'},
          {label: 'I - Investimento', value: 'I'},
        ]
        this.siglaPorte = [
          {label: LabelSiglaPorte.get(SiglaPorte.MICROEMPREENDEDOR_INDIVIDUAL), value: SiglaPorte.MICROEMPREENDEDOR_INDIVIDUAL},
          {label: LabelSiglaPorte.get(SiglaPorte.MICRO_EMPRESA), value: SiglaPorte.MICRO_EMPRESA},
          {label: LabelSiglaPorte.get(SiglaPorte.PEQUENA_EMPRESA), value: SiglaPorte.PEQUENA_EMPRESA}
        ]
        this.dataSistemaService.getDataCorrente().subscribe(dataCorrente => {
          this.dataReferenciaDefault = moment(dataCorrente).toDate();
          this.dataInicioMinimoCadastroLimiteOperacao = moment(dataCorrente).add(1, "day").toDate();
        });
    }

    ngOnDestroy(): void {
      this.destroy$.next(undefined);
      this.destroy$.complete();
    }

    public onTabChange($event: NgbNavChangeEvent) {
      this.abaAtiva = $event.nextId;



      if(!this.vigenciasFatorEcg && this.abaAtiva === "fatores de ecg") {
        this.buscarVigenciasFatorEcg();
      }
      if(!this.eventosDistribuicao && this.abaAtiva === "evento distribuicao") {
        this.buscarEventosDistribuicao();
      }
      if(!this.fatoresReducaoEcg && this.abaAtiva === "reducao_ecg") {
        this.buscarFatorRedutorEcg();
      }

      if(!this.porteBeneficiario  && this.abaAtiva === "porte_beneficiario") {

        this.carregaPorteBeneficiarioTranche();

      }

      if(this.verPortesDesativados && this.abaAtiva === "porte_beneficiario") {
        this.verPortesDesativados = false;
        this.carregaPorteBeneficiarioTranche();

      }



    }

    mudancaPagina(novaPagina: EntityPagedRequestParameters) {

      this.atributosPaginacao = novaPagina;
      this.pesquisar(this.atributosPaginacao);

    }

    pesquisar(pesq: EntityPagedRequestParameters) {

      let posInicial, posFinal;
      posInicial = (pesq.page - 1) * pesq.pageSize;
      posFinal = posInicial + pesq.pageSize;
      if(this.model.historicos == null) return;
      if (posFinal > this.model.historicos.length) {
        posFinal = this.model.historicos.length;
      }

      this.listaHistoricos = this.model.historicos.slice(posInicial, posFinal);
      this.countHistoricos = this.model.historicos.length;

    }

    public preparaModelo(): Observable<Tranche> {
        return this.route.params.pipe(
          mergeMap((params) => {
            if (params['id']) {
              return this.tranchesService.findById(params['id']);
            } else {
              const novo = new Tranche();
              super.editar();
              this.mostraAbas = false;
              return of(novo);
            }
          })
        );
    }

    public createReactiveForm(): UntypedFormGroup {
       const form = this.formBuilder.group({
            numeroTranche:[{value: null}, Validators.required] ,
            dataInicioContratacao:[{value: null}, Validators.required] ,
            dataFimContratacao: [{value: null}, Validators.required],
            dataInicioProtocolo: [{value: null}, Validators.required] ,
            dataFimProtocolo: [{value: null}, Validators.required],
            siglaModalidadeGarantia: [{value: null}],
            dataFimLiberacoes:[{value: null}, Validators.required] ,
            dataFimRetificacoes: [{value: null}],
            percentualGarantidoEmbutidoTaxaStopLoss:[{value: null}],
            valorFaturamentoMinimo:[{value: null}],
            valorFaturamentoMaximo: [{value: null}],
            valorCreditoMinimo:[{value: null}, Validators.required] ,
            valorLimiteTotalBeneficiario: [{value: null}],
            idTipoCalculoLimite: [{value: null}, Validators.required],
            idTipoCalculoLimiteAgenteFinanceiro : [{value: null}],
            indicadorAditivoHabilitado: [{value: null}],
            indicadorLimiteEspecialHabilitado: [{value: null}],
            quantidadeDiasLimiteRetificacao: [{value: null}, Validators.required],
            quantidadeDiasLimiteAditivo: [{value: null}],
            dataInicioCobrancaEcg: [{value:null}],
            dataFimCobrancaEcg: [{value:null}]
        });

        return form;
    }

    public createReactiveFormFatorRedutor(): FormGroup {
      const form = this.formBuilder.group({
           fatorRedutor:[null, Validators.required],
           limiteInferior:[null, Validators.required],
           limiteSuperior:[null, Validators.required]
       });
       return form;
   }

    public createReactiveFormTaxaStopLoss(): FormGroup {
      const form = this.formBuilder.group({
            dataInicioValidade:[null, Validators.required],
            siglaPorteBeneficiario:[null, Validators.required],
            taxa:[null,[Validators.required, Validators.max(1)]]
        });
        return form;
   }
   public createReactiveFormLimiteContratacaoBeneficiario(): FormGroup {
      const form = this.formBuilder.group({
           dataInicioValidade:[null, Validators.required],
           valor:[null, Validators.required]
       });
       return form;
   }
   public createReactiveFormLimiteContratacaoOperacao(): FormGroup {
    const form = this.formBuilder.group({
         dataInicioValidade:[null, Validators.required],
         objetivoFinanciamento:[null, Validators.required],
         siglaPorte:[null, Validators.required],
         valor:[null, Validators.required]
     });
     return form;
 }
   public createReactiveFormPrazoContratacao(modalidade: string): FormGroup {
      const form = this.formBuilder.group({
        dataInicioValidade:[null, Validators.required],
        quantidadeMesesPrazoMinimoCarencia:[null, Validators.required],
        quantidadeMesesPrazoMaximoCarencia:[null, modalidade !== MODALIDADE_GARANTIA_FGBS ? Validators.required : null],
        quantidadeMesesPrazoMinimoTotal:[null, Validators.required],
        quantidadeMesesPrazoMaximoTotal:[null, Validators.required]
       });
       return form;
   }

   public createReactiveFormNovaVigenciaFatorEcg(): FormGroup {
    const form = this.formBuilder.group({
      dataInicioVigencia:[null, Validators.required],
      dataFimVigencia:[{value: null, disabled: true}],
      fatoresEcg:this.formBuilder.array([])
     });
     return form;
   }

   public createReactiveFormVigenciaFatorEcg(): FormGroup {
    const form = this.formBuilder.group({
      dataInicioVigencia:[{value: null, disabled: true}],
      dataFimVigencia:[{value: null, disabled: true}],
      fatoresEcg:this.formBuilder.array([])
     });
     return form;
   }

   public createReactiveFormEventoDistribuicao(): FormGroup {
    const form = this.formBuilder.group({
      agenteFinanceiro:[null, Validators.required],
      dataEvento:[null, Validators.required]
    });
    return form;
   }

   public createReactiveFormNovoFatorRedutorEcg(): FormGroup {
    const form = this.formBuilder.group({
      dataInicioVigencia:[null, Validators.required],
      valorFatorRedutorEcg:[null, Validators.required]
     });
     return form;
   }

   public createReactiveFormEncerrarFatorRedutorEcg(): FormGroup {
    const form = this.formBuilder.group({
      dataInicioVigencia:[null, Validators.required],
      dataFimVigencia:[null, Validators.required]
     });
     return form;
   }

   public createReactiveFormEncerrarLimiteContratacaoOperacao(): FormGroup {
    const form = this.formBuilder.group({
      dataInicioValidade:[null, Validators.required],
      dataFimValidade:[null, Validators.required]
     });
     return form;
   }

   public createReactiveFormPorteBeneficario(): FormGroup {
    const form = this.formBuilder.group({
      dataInicioValidade:[null, Validators.required],
      dataFimValidade:[null],
      porteEmpresa:[null, Validators.required],
      faturamentoMinimo:[null, Validators.required],
      faturamentoMaximo:[null]
     });
     return form;
   }

   public createReactiveFormEncerrarPorteBeneficiario(): FormGroup {
    const form = this.formBuilder.group({
      dataInicioValidade:[null, Validators.required],
      dataFimValidade:[null, Validators.required]
     });
     return form;
   }

   preencheForm(model:Tranche){
        this.formTranche.patchValue({
            numeroTranche: model.numeroTranche,
            dataInicioContratacao: model.dataInicioContratacao == null ? null : moment(model.dataInicioContratacao).toDate(),
            dataFimContratacao: model.dataFimContratacao == null ? null : moment(model.dataFimContratacao).toDate(),
            dataInicioProtocolo: model.dataInicioProtocolo == null ? null : moment(model.dataInicioProtocolo).toDate(),
            dataFimProtocolo: model.dataFimProtocolo == null ? null : moment(model.dataFimProtocolo).toDate(),
            siglaModalidadeGarantia: model.siglaModalidadeGarantia,
            dataFimLiberacoes: model.dataFimLiberacoes == null ? null : moment(model.dataFimLiberacoes).toDate(),
            dataFimRetificacoes: model.dataFimRetificacoes == null ? null : moment(model.dataFimRetificacoes).toDate(),
            percentualGarantidoEmbutidoTaxaStopLoss: model.percentualGarantidoEmbutidoTaxaStopLoss,
            valorFaturamentoMinimo: model.valorFaturamentoMinimo,
            valorFaturamentoMaximo: model.valorFaturamentoMaximo,
            valorCreditoMinimo: model.valorCreditoMinimo,
            valorLimiteTotalBeneficiario: model.valorLimiteTotalBeneficiario,
            idTipoCalculoLimite: model.idTipoCalculoLimite,
            idTipoCalculoLimiteAgenteFinanceiro: model.idTipoCalculoLimiteAgenteFinanceiro,
            indicadorAditivoHabilitado: model.indicadorAditivoHabilitado,
            quantidadeDiasLimiteRetificacao: model.quantidadeDiasLimiteRetificacao,
            indicadorLimiteEspecialHabilitado: model.indicadorLimiteEspecialHabilitado,
            quantidadeDiasLimiteAditivo: model.quantidadeDiasLimiteAditivo,
            dataInicioCobrancaEcg: model.dataInicioCobrancaEcg == null ? null : moment(model.dataInicioCobrancaEcg).toDate(),
            dataFimCobrancaEcg: model.dataFimCobrancaEcg == null ? null : moment(model.dataFimCobrancaEcg).toDate()
        });
    }

    preencheFormVigenciaFatorEcg(vigencia: VigenciaFatorEcg) {
      this.formVigenciaFatorEcg.patchValue({
        dataInicioVigencia: vigencia.dataInicioVigencia == null ? null : moment(vigencia.dataInicioVigencia).toDate(),
        dataFimVigencia: vigencia.dataFimVigencia == null ? null : moment(vigencia.dataFimVigencia).toDate(),
        fatoresEcg: vigencia.fatoresEcg
      });

      if (this.encerrarFator) {
        this.formVigenciaFatorEcg.get('dataFimVigencia').enable();
        this.permissaoEditar = false;
        this.permissaoSalvar = true;
      } else if (moment().isBefore(moment(vigencia.dataInicioVigencia))) {
        this.permissaoEditar = true;
        this.permissaoSalvar = true;
        this.formVigenciaFatorEcg.get('dataInicioVigencia').enable();
      } else {
        this.permissaoEditar = false;
        this.permissaoSalvar = false;
      }
    }

    deveExibirBotaoExcluirEncerrarLimiteContratacao(limite: LimiteContratacaoOperacao) {
      return (moment(this.dataReferenciaDefault).isBefore(limite.dataFimValidade)
              ||  (limite.dataFimValidade == null || limite.dataFimValidade == undefined));
    }

    rowDisabled(limite: LimiteContratacaoOperacao) {
      return limite.dataFimValidade != null && moment(this.dataReferenciaDefault).isAfter(limite.dataFimValidade);
    }

    exibirExcluirOuEncerrar(dataInicioValidade: Date) {
      return moment(this.dataReferenciaDefault).isAfter(dataInicioValidade);
    }

    habilitarEdicao() {
        this.formTranche.get('dataInicioContratacao').enable();
        this.formTranche.get('dataFimContratacao').enable();
        this.formTranche.get('dataInicioProtocolo').enable();
        this.formTranche.get('dataFimProtocolo').enable();
        this.formTranche.get('siglaModalidadeGarantia').enable();
        this.formTranche.get('dataFimLiberacoes').enable();
        this.formTranche.get('dataFimRetificacoes').enable();
        this.formTranche.get('percentualGarantidoEmbutidoTaxaStopLoss').enable();
        this.formTranche.get('valorFaturamentoMinimo').enable();
        this.formTranche.get('valorFaturamentoMaximo').enable();
        this.formTranche.get('valorCreditoMinimo').enable();
        this.formTranche.get('valorLimiteTotalBeneficiario').enable();
        this.formTranche.get('idTipoCalculoLimite').enable();
        this.formTranche.get('idTipoCalculoLimiteAgenteFinanceiro').enable();
        this.formTranche.get('indicadorAditivoHabilitado').enable();
        this.formTranche.get('quantidadeDiasLimiteRetificacao').enable();
        this.formTranche.get('indicadorLimiteEspecialHabilitado').enable();
        this.formTranche.get('quantidadeDiasLimiteAditivo').enable();
        this.formTranche.get('dataInicioCobrancaEcg').enable();
        this.formTranche.get('dataFimCobrancaEcg').enable();
        super.editar();

    }

    desabilitarEdicao() {
      this.formTranche.get('dataInicioContratacao').disable();
      this.formTranche.get('dataFimContratacao').disable();
      this.formTranche.get('dataInicioProtocolo').disable();
      this.formTranche.get('dataFimProtocolo').disable();
      this.formTranche.get('siglaModalidadeGarantia').disable();
      this.formTranche.get('dataFimLiberacoes').disable();
      this.formTranche.get('dataFimRetificacoes').disable();
      this.formTranche.get('percentualGarantidoEmbutidoTaxaStopLoss').disable();
      this.formTranche.get('valorFaturamentoMinimo').disable();
      this.formTranche.get('valorFaturamentoMaximo').disable();
      this.formTranche.get('valorCreditoMinimo').disable();
      this.formTranche.get('valorLimiteTotalBeneficiario').disable();
      this.formTranche.get('idTipoCalculoLimite').disable();
      this.formTranche.get('idTipoCalculoLimiteAgenteFinanceiro').disable();
      this.formTranche.get('indicadorAditivoHabilitado').disable();
      this.formTranche.get('quantidadeDiasLimiteRetificacao').disable();
      this.formTranche.get('indicadorLimiteEspecialHabilitado').disable();
      this.formTranche.get('quantidadeDiasLimiteAditivo').disable();
      this.formTranche.get('dataInicioCobrancaEcg').disable();
      this.formTranche.get('dataFimCobrancaEcg').disable();
      super.editar();
  }

    salvar() {
      this.atualizaModel();
      console.debug("model: " + JSON.stringify(this.model));
      this.abreModalConfirmacao(this.model.id != null ?
        'Deseja confirmar a alteração dos dados da cesta?' : 'Deseja confirmar o cadastro da cesta?')
        .then(resp => {
          if (resp === true) {
            this.loadingService.bloqueiaTela();
            const acao  = this.model.id != null ?
              this.tranchesService.atualizarTranche(this.model.id, this.model) : this.tranchesService.salvarTranche(this.model);
            acao.subscribe(
              trancheRetornada => {
                console.log(trancheRetornada);
                this.model = trancheRetornada;
                this.loadingService.liberaTela();
                this.aposSalvar();
              },
              error => {
                console.log(error);
                this.ocorrencias = this.tranchesService.ocorrencias;
                this.loadingService.liberaTela();
              }
            )
          }
        })
    }

    public salvarFatorRedutor() {

      this.loadingService.bloqueiaTela();
      const dto = this.formFatorRedutor.value;
      console.log("Chamando verificarInclusaoFatorRedutor():")
        if(this.verificarInclusaoFatorRedutor(this.model.fatoresRedutores, dto) == true){
        this.tranchesService.salvarFatorRedutor(this.model.id, dto).subscribe(() => {
          this.mensagemService.adicionarMensagemSucesso('Fator redutor incluído com sucesso.');
          this.preparaModelo().subscribe((tranche) => {
            this.setModel(tranche);
            this.formFatorRedutor.reset();
            this.loadingService.liberaTela();
        });
        }, (error) => {
          this.loadingService.liberaTela();
        });
      }
    }
    public verificarInclusaoFatorRedutor(listaFatoresRedutores, novoFatorRedutor) {
      // Verificar se o novo intervalo se sobrepõe a algum intervalo existente
      for (const fatorRedutor of listaFatoresRedutores) {
        if (novoFatorRedutor.limiteInferior >= fatorRedutor.limiteInferior && novoFatorRedutor.limiteInferior < fatorRedutor.limiteSuperior) {
          console.log("O novo intervalo se sobrepõe a um intervalo existente")

            this.mensagemService.adicionarMensagemErro('O novo fator redutor não pode ser incluído pois sobrepõe um já existem.');
            this.loadingService.liberaTela();

          return false; // O novo intervalo se sobrepõe a um intervalo existente
        }
        if (novoFatorRedutor.limiteSuperior >= fatorRedutor.limiteInferior && novoFatorRedutor.limiteSuperior <= fatorRedutor.limiteSuperior) {
          console.log("O novo intervalo se sobrepõe a um intervalo existente")


          this.mensagemService.adicionarMensagemErro('O novo fator redutor não pode ser incluído pois sobrepõe um já existem.');
          this.loadingService.liberaTela();

          return false; // O novo intervalo se sobrepõe a um intervalo existente
        }
        if(novoFatorRedutor.limiteInferior >= novoFatorRedutor.limiteSuperior){
          this.mensagemService.adicionarMensagemErro('O novo limite inferior deve ser menor que o limite superior');
          this.loadingService.liberaTela();

          return false;
        }
      }
      console.log("O novo fator redutor pode ser incluído")
      return true; // O novo fator redutor pode ser incluído
    }

    public salvarTaxaStopLoss() {

          this.loadingService.bloqueiaTela();

          const taxaValue = this.formTaxaStopLoss.controls.taxa.value;
          const dto = this.formTaxaStopLoss.value;
          this.tranchesService.salvarTaxaStopLoss(this.model.id, dto).subscribe(() => {

            this.mensagemService.adicionarMensagemSucesso('Taxa Stop Loss incluída com sucesso.');
            this.preparaModelo().subscribe((tranche) => {
              this.setModel(tranche);
              this.formTaxaStopLoss.reset();
              this.loadingService.liberaTela();
          });

          }, (error) => {
            this.loadingService.liberaTela();
            this.mensagemService.adicionarMensagemErro('Erro ao salvar Taxa Stop Loss.');
          });
    }

    public salvarLimiteContratacaoBeneficiario() {

          this.loadingService.bloqueiaTela();
          const dto = this.formLimiteContratacaoBeneficiario.value;
          this.tranchesService.salvarLimiteContratacaoBeneficiario(this.model.id, dto).subscribe(() => {
            this.mensagemService.adicionarMensagemSucesso('Limite Contratacao Beneficiário incluído com sucesso.');
            this.preparaModelo().subscribe((tranche) => {
              this.setModel(tranche);
              this.formLimiteContratacaoBeneficiario.reset();
            this.loadingService.liberaTela();
          });
          }, (error) => {
            this.loadingService.liberaTela();
          });
    }

    public salvarLimiteContratacaoOperacao() {
      this.loadingService.bloqueiaTela();
      const dto = this.formLimiteContratacaoOperacao.value;
      this.tranchesService.salvarLimiteContratacaoOperacao(this.model.id, dto).subscribe(() => {
        this.mensagemService.adicionarMensagemSucesso('Limite Contratacao Operação incluído com sucesso.');
        this.preparaModelo().subscribe((tranche) => {
          this.setModel(tranche);
          this.formLimiteContratacaoOperacao.reset();
        this.loadingService.liberaTela();
        this.fecharModalLimiteContratacaoOperacao();
      });
      }, (error) => {
        this.loadingService.liberaTela();
      });
}

    public salvarPrazoContratacao() {

          this.loadingService.bloqueiaTela();
          const dto = this.formPrazoContratacao.value;
          this.tranchesService.salvarPrazoContratacao(this.model.id, dto).subscribe(() => {

            this.mensagemService.adicionarMensagemSucesso('Prazo contratação incluído com sucesso.');
            this.preparaModelo().subscribe((tranche) => {
              this.setModel(tranche);
              this.formPrazoContratacao.reset();
              this.loadingService.liberaTela();
              this.modalService.dismiss();
          });

          }, (error) => {
            this.loadingService.liberaTela();
          });
    }

    public salvarVigenciaFatorEcg(idVigenciaFatorEcg: number): void {   //salvar modal Vigência de Fatores de ECG
      this.loadingService.bloqueiaTela();
      const dto = this.formVigenciaFatorEcg.value;
      const fatoresEcg: FatorEcg[] = this.vigenciaFatorEcg.fatoresEcg;
      dto.fatoresEcg = fatoresEcg;

      this.tranchesService.salvarVigenciaFatorEcg(this.model.id, idVigenciaFatorEcg, dto).subscribe((data: any) => {
        if (this.encerrarFator) {
          this.mensagemService.adicionarMensagemSucesso('Vigência encerrada com sucesso.');
        } else {
          this.mensagemService.adicionarMensagemSucesso('Fatores de ECG incluídos com sucesso.');
        }
        this.buscarVigenciasFatorEcg();
        this.loadingService.liberaTela();

        this.permissaoSalvar = false;
        this.fecharModalVigenciaFatorEcg();
      }, (error) => {
        this.buscarVigenciasFatorEcg();
        this.loadingService.liberaTela();
      });
    }

    public salvarNovaVigenciaFatorEcg(): void {
      this.loadingService.bloqueiaTela();
      const dto = this.formNovaVigenciaFatorEcg.value;
      let ultimaVigencia: VigenciaFatorEcg

      if(this.vigenciasFatorEcg.length > 0) {
        ultimaVigencia = this.vigenciasFatorEcg[this.vigenciasFatorEcg.length - 1];
      }

      this.tranchesService.salvarNovaVigenciaFatorEcg(this.model.id, ultimaVigencia?.id, dto).subscribe((data: any) => {
        this.mensagemService.adicionarMensagemSucesso('Nova vigência de fatores cadastrada com sucesso.');
        this.buscarVigenciasFatorEcg();
        this.loadingService.liberaTela();

      }, (error) => {
        this.buscarVigenciasFatorEcg();
        this.loadingService.liberaTela();
      });

      this.fecharModalNovaVigenciaFatorEcg();
    }

    public salvarNovoFatorRedutorEcg(): void {
      this.loadingService.bloqueiaTela();
      const dto = this.formNovoFatorRedutorEcg.value;
      let ultimoFator: FatorReducaoEcg

      if(this.fatoresReducaoEcg.length > 0) {
        ultimoFator = this.fatoresReducaoEcg[this.fatoresReducaoEcg.length - 1];
      }

      this.tranchesService.salvarNovoFatorRedutorEcg(this.model.id, ultimoFator?.id, dto).subscribe(() => {
        this.mensagemService.adicionarMensagemSucesso('Novo % Redução cadastrado com sucesso.');
        this.buscarFatorRedutorEcg();
        this.loadingService.liberaTela();
      }, (error) => {
        this.buscarFatorRedutorEcg();
        this.loadingService.liberaTela();
      });

      this.fecharModalNovoFatorRedutorEcg();
    }

    public abrirModalDuplicaVigencia(event: Event, idVigencia: number): void {
      event.stopPropagation();
      this.idDuplicacao = idVigencia;
      this.abrirModalDuplicarVigenciaFatorEcg('', 'lg', true, true);
    }

    public duplicaVigenciaFatorEcg(): void {
      this.loadingService.bloqueiaTela();
      const dto = this.formNovaVigenciaFatorEcg.value;

      this.tranchesService.duplicarVigenciaFatorEcg(this.model.id, this.idDuplicacao, dto).subscribe((data: any) => {
        this.mensagemService.adicionarMensagemSucesso('Nova vigência de fatores cadastrada com sucesso.');
        this.buscarVigenciasFatorEcg();
        this.loadingService.liberaTela();

      }, (error) => {
        this.buscarVigenciasFatorEcg();
        this.loadingService.liberaTela();
      });

      this.fecharModalNovaVigenciaFatorEcg();
    }

    public salvarEventoDistribuicao(): void {

      this.loadingService.bloqueiaTela();
      const dto = this.formEventoDistribuicao.value;
      this.tranchesService.salvarEventoDistribuicao(this.model.id, dto).subscribe((data: any) => {

        this.messageService.addMessage({
          title: 'Sucesso',
          type: 'CRUD_OPERATION',
          level: messageLevel.SUCCESS,
          message: 'Retorno do agente cadastrado com sucesso.'
        });
        this.preparaModelo().subscribe((tranche) => {
          this.setModel(tranche);
          this.formEventoDistribuicao.reset();
          this.loadingService.liberaTela();
          this.eventosDistribuicao.unshift(data);

      });

      }, (error) => {
        this.loadingService.liberaTela();
      });
      this.fecharModalEventoDistribuicao();
  }

    public buscarHistorico(idHistorico: number) {
      this.tranchesService.buscarHistoricoTranche(idHistorico)
        .subscribe((historico: HistoricoTranche[]) => {
        this.historico = historico;
        this.pesquisado = true;
      });
    }

    public buscarEventosDistribuicao(): void {
      this.tranchesService.buscarEventosDistribuicao(this.model.id).subscribe((data: any) => {
        this.eventosDistribuicao = data;
      });
    }

    public buscarAgentesFinanceiros(): void {
      this.agenteFinanceiroService.getAgentesFinanceiros().subscribe((data: any) => {
        this.agentesFinanceirosHabilitados = data;
      });
    }

    public buscarVigenciasFatorEcg(): void {
      this.dataFimDaTranche = new Date(this.model.dataFimProtocolo)
      this.tranchesService.buscarVigenciasFatorEcg(this.model.id).subscribe((data: any) => {
        this.vigenciasFatorEcg = data;
      });
    }

    public buscarFatorRedutorEcg(): void {
      this.dataFimDaTranche = new Date(this.model.dataFimProtocolo);
      this.tranchesService.buscarFatorRedutorEcg(this.model.id).subscribe((data: any) => {
        this.fatoresReducaoEcg = data;
      });
    }

    public buscarCiclosMetaDescumprida(evento: EventoDistribuicao): void {
      this.tranchesService.buscarCiclosMetaDescumprida(this.model.id, evento.idEventoDistribuicaoLimiteAgenteFinanceiro).subscribe((data: any) => {
        this.listaCiclosMetaDescumprida = data
                                          .sort((a, b) => (b.dataFim ?? '').localeCompare(a.dataFim ?? ''))
                                          .slice(0, 2);
        this.abrirCiclosMetaDescumprida();
      });
    }

    atualizaModel(){

      this.model.numeroTranche = this.formTranche.get('numeroTranche').value;
      this.model.dataInicioContratacao = this.formTranche.get('dataInicioContratacao').value;
      this.model.dataFimContratacao = this.formTranche.get('dataFimContratacao').value;
      this.model.dataInicioProtocolo = this.formTranche.get('dataInicioProtocolo').value;
      this.model.dataFimProtocolo = this.formTranche.get('dataFimProtocolo').value;
      this.model.siglaModalidadeGarantia = this.formTranche.get('siglaModalidadeGarantia').value;
      this.model.dataFimLiberacoes = this.formTranche.get('dataFimLiberacoes').value;
      this.model.dataFimRetificacoes = this.formTranche.get('dataFimRetificacoes').value;
      this.model.percentualGarantidoEmbutidoTaxaStopLoss = this.formTranche.get('percentualGarantidoEmbutidoTaxaStopLoss').value == true ? true : false;
      this.model.valorFaturamentoMinimo = this.formTranche.get('valorFaturamentoMinimo').value;
      this.model.valorFaturamentoMaximo = this.formTranche.get('valorFaturamentoMaximo').value;
      this.model.valorCreditoMinimo = this.formTranche.get('valorCreditoMinimo').value;
      this.model.valorLimiteTotalBeneficiario = this.formTranche.get('valorLimiteTotalBeneficiario').value;
      this.model.idTipoCalculoLimite = this.formTranche.get('idTipoCalculoLimite').value;
      this.model.idTipoCalculoLimiteAgenteFinanceiro =  this.formTranche.get('idTipoCalculoLimiteAgenteFinanceiro').value;
      this.model.indicadorAditivoHabilitado = this.formTranche.get('indicadorAditivoHabilitado').value == true ? true : false;
      this.model.quantidadeDiasLimiteRetificacao = this.formTranche.get('quantidadeDiasLimiteRetificacao').value;
      this.model.indicadorLimiteEspecialHabilitado = this.formTranche.get('indicadorLimiteEspecialHabilitado').value == true ? true : false;
      this.model.quantidadeDiasLimiteAditivo = this.formTranche.get('quantidadeDiasLimiteAditivo').value;
      this.model.dataInicioCobrancaEcg = this.formTranche.get('dataInicioCobrancaEcg').value;
      this.model.dataFimCobrancaEcg = this.formTranche.get('dataFimCobrancaEcg').value;

    }

    voltarParaLista() {
      this.router.navigate(['/tranches/listagem']);
    }

    aposSalvar() {
        this.exibeMensagemSucesso();
        this.formTranche.markAsPristine();
        super.alternarEdicao();
        this.mostraAbas = true;
    }

    exibeMensagemSucesso(): void {
      const mensagem = this.model.id != null ? 'Tranche atualizada com sucesso.' : 'Tranche cadastrada com sucesso.'
      this.mensagemService.adicionarMensagemSucesso(mensagem);
    }

    async verificaSePodeSair(): Promise<boolean> {
        const titulo = 'Confirmação';
        const mensagem = this.model.id!=null ? 'Descartar alterações realizadas na cesta?' : 'Descartar novo cadastro de cesta?';

        try {
            const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
            return resultadoConfimacao.value === 'ok';
        } catch (e) {
            return false;
        }
    }

    canDeactivate(): Promise<boolean> | boolean {
      if (!this.modoEdicao || this.formTranche.valid || this.formTranche.pristine)
        return true;

      return this.verificaSePodeSair();
    }

    async abreModalConfirmacao(mensagem: string): Promise<boolean> {
      const titulo = 'Confirmação';

      try {
          const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
          return resultadoConfimacao.value === 'ok';
      } catch (e) {
          return false;
      }
    }

    public desabilitaCheckbox() {
      if(this.modoEdicao){
        this.formTranche.get('percentualGarantidoEmbutidoTaxaStopLoss').enable();
        this.formTranche.get('indicadorAditivoHabilitado').enable();
        this.formTranche.get('indicadorLimiteEspecialHabilitado').enable();
      } else {
        this.formTranche.get('percentualGarantidoEmbutidoTaxaStopLoss').disable();
        this.formTranche.get('indicadorAditivoHabilitado').disable();
        this.formTranche.get('indicadorLimiteEspecialHabilitado').disable();
      }
    }

    ordenarFatoresRedutores(fatoresRedutores) {
      if(fatoresRedutores == null) return;
      fatoresRedutores.sort((a, b) => {
        const fatorRedutorA = parseFloat(a.fatorRedutor);
        const fatorRedutorB = parseFloat(b.fatorRedutor);

        if (fatorRedutorA < fatorRedutorB) {
          return -1;
        } else if (fatorRedutorA > fatorRedutorB) {
          return 1;
        } else {
          const limiteInferiorA = parseFloat(a.limiteInferior);
          const limiteInferiorB = parseFloat(b.limiteInferior);

          if (limiteInferiorA < limiteInferiorB) {
            return -1;
          } else if (limiteInferiorA > limiteInferiorB) {
            return 1;
          } else {
            return 0;
          }
        }
      });
    }

    public abrirModalFatorRedutor(msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean) {
      if (hasBotoes === true && hasMsgTemplate === true) {
        this.modalService.abrir('Inclusão de Fator Redutor', msg, tamanho, this.msgPersonalizadaFatorRedutor, this.botoesPersonalizadosFatorRedutor);
      }
    }
    public abrirModalTaxaStopLoss(msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean) {
      if (hasBotoes === true && hasMsgTemplate === true) {
        this.modalService.abrir('Inclusão de Taxa Stop Loss', msg, tamanho, this.msgPersonalizadaTaxaStopLoss, this.botoesPersonalizadosTaxaStopLoss);
      }
    }
    public abrirModalLimiteContratacaoBeneficiario(msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean) {
      if (hasBotoes === true && hasMsgTemplate === true) {
        this.modalService.abrir('Inclusão de Limite Contratação Beneficiário', msg, tamanho, this.msgPersonalizadaLimiteContratacaoBeneficiario, this.botoesPersonalizadosLimiteContratacaoBeneficiario);
      }
    }
    public abrirModalLimiteContratacaoOperacao(msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean) {
      if (hasBotoes === true && hasMsgTemplate === true) {
        this.modalService.abrir('Inclusão de Limite Contratação Operação', msg, tamanho, this.msgPersonalizadaLimiteContratacaoOperacao, this.botoesPersonalizadosLimiteContratacaoOperacao);
      }
    }
    public abrirModalPrazoContratacao(msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean) {
      if (hasBotoes === true && hasMsgTemplate === true) {
        this.modalService.abrir('Inclusão de Prazo Contratação', msg, tamanho, this.msgPersonalizadaPrazoContratacao, this.botoesPersonalizadosPrazoContratacao);
      }
    }

    public abrirModalNovaVigenciaFatorEcg(msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean): void {
      if (hasBotoes === true && hasMsgTemplate === true) {
        this.modalService.abrir('Criar Nova Vigência de Fatores de ECG', msg, tamanho, this.msgNovaVigenciaFatorEcg, this.botoesNovaVigenciaFatorEcg);
      }
    }

    public abrirModalNovoFatorRedutorEcg(msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean): void {
      if (hasBotoes === true && hasMsgTemplate === true) {
        this.modalService.abrir('Inclusão de % Redução ECG', msg, tamanho, this.msgNovoFatorRedutorEcg, this.botoesNovoFatorRedutorEcg);
      }
    }

    public abrirModalEncerrarFatorRedutorEcg(msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean): void {
      if (hasBotoes === true && hasMsgTemplate === true) {
        this.modalService.abrir('Inclusão de % Redução ECG', msg, tamanho, this.msgNovoFatorRedutorEcg, this.botoesNovoFatorRedutorEcg);
      }
    }

    public abrirModalDuplicarVigenciaFatorEcg(msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean): void {
      if (hasBotoes === true && hasMsgTemplate === true) {
        this.modalService.abrir('Duplicar Vigência de Fatores de ECG', msg, tamanho, this.msgDuplicaVigenciaFatorEcg, this.botoesDuplicaVigenciaFatorEcg);
      }
    }

    public abrirModalEncerrarVigenciaFatorEcg(event, msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean, vigenciaFatorEcg?: VigenciaFatorEcg) {
      event.stopPropagation();
      this.abrirModalVigenciaFatorEcg(msg, tamanho, hasBotoes, hasMsgTemplate, vigenciaFatorEcg, true);
    }

    public abrirModalVigenciaFatorEcg(msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean, vigenciaFatorEcg?: VigenciaFatorEcg, encerrarFatorEcg?: boolean) {

      this.tranchesService.buscarVigenciaFatorEcg(vigenciaFatorEcg.id).subscribe((data: any) => {
        vigenciaFatorEcg.fatoresEcg = data;

        this.encerrarFator = encerrarFatorEcg;
        this.preencheFormVigenciaFatorEcg(vigenciaFatorEcg);

        if(vigenciaFatorEcg) {
          this.vigenciaFatorEcg = vigenciaFatorEcg;
        }

        if (hasBotoes === true && hasMsgTemplate === true) {
          // Formata o ID com HTML e estilos embutidos
          const idFormatado = `<small class="text-muted" style="font-size: 23px">(#ID: ${vigenciaFatorEcg.id})</small>`;

          // Obtém a referência da modal sem abrir
          const modalRef = this.modalService.abrir('', msg, tamanho, this.msgVigenciaFatorEcg, this.botoesVigenciaFatorEcg);

          // Adiciona o HTML ao título da modal
          const modalTitle = modalRef['_windowCmptRef'].location.nativeElement.querySelector('.modal-title');
          modalTitle.innerHTML = `${this.encerrarFator ? 'Encerrar' : ''} Vigência de Fatores de ECG ${idFormatado}`;
        }
      });
    }
    public abrirModalEventoDistribuicao(msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean) {
      if (hasBotoes === true && hasMsgTemplate === true) {
        this.modalService.abrir('Inclusão de Retorno Agente Financeiro', msg, tamanho, this.msgPersonalizadaEventoDistribuicao, this.botoesPersonalizadosEventoDistribuicao);
      }
    }

    public abrirModalFatorEcg(fatorEcg: FatorEcg): void { //Ação Modal Inclusão de Fator de ECG
      const modalRef: NgbModalRef = this.abrirModal.open(ModalFatorEcgComponent);

      const fatoresEcg: FatorEcg[] = this.vigenciaFatorEcg.fatoresEcg;
      this.fatorEcgEdicao = fatorEcg;

      if (fatorEcg) {
        modalRef.componentInstance.fatoresEcg = [];
        modalRef.componentInstance.fatorEdicao = fatorEcg;
      } else {
        modalRef.componentInstance.fatoresEcg = fatoresEcg;
        modalRef.componentInstance.fatorEdicao = null;
      }

      modalRef.result.then((resultado) => {
        if(resultado.botao === 'salvar') {
          if(this.vigenciaFatorEcg) {

            //let fatoresEcgArray;

            if (resultado.inclusao) {
              this.vigenciaFatorEcg.fatoresEcg.push(resultado.valor);
            } else {
              this.fatorEcgEdicao.valorFatorEcg = resultado.valor.valorFatorEcg;
              this.fatorEcgEdicao.quantidadeMesesPrazoTotalFinal = resultado.valor.quantidadeMesesPrazoTotalFinal;
            }

            this.tranchesService.calcularFatores(this.vigenciaFatorEcg.fatoresEcg).subscribe(fatores => this.vigenciaFatorEcg.fatoresEcg = fatores);
          }
          else {
            this.fecharModalVigenciaFatorEcg()
          }
        }
      });
    }

    public abrirModalPorteBeneficiario(msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean) {
      if (hasBotoes === true && hasMsgTemplate === true) {
        this.modalService.abrir('Inclusão de Limite Contratação Operação', msg, tamanho, this.msgTemplatePorteBeneficiario, this.botoesPorteBeneficiario);
      }
    }

    public salvarPorteBeneficiario() {
      this.loadingService.bloqueiaTela();
      const dto = this.formPorteBeneficario.value;
      this.tranchesService.incluirPorte(this.model.id, dto).subscribe((data: any) => {
        this.mensagemService.adicionarMensagemSucesso('A Sigla do Porte Beneficiário foi incluída com sucesso.');

        this.loadingService.liberaTela();
        this.carregaPorteBeneficiarioTranche();

        this.fecharModalPorteBeneficiario();
      }, (error) => {
        this.loadingService.liberaTela();
      });
    }

    public excluirFatorEcg(): void {
      this.loadingService.bloqueiaTela();
      this.tranchesService.excluirFatorEcg(this.model.id, this.idExclusao).subscribe((data: any) => {
        this.mensagemService.adicionarMensagemSucesso('Vigência Fator K excluída com sucesso.');
        this.vigenciasFatorEcg = data;
        this.close();
        this.loadingService.liberaTela();
      });
    }

    public excluirLimiteContratacaoOperacao(): void {
      this.loadingService.bloqueiaTela();
      let dto: any = {};
      dto.id = this.idExclusao;
      dto.dataInicioValidade = this.dataInicioValidade;
      this.tranchesService.excluirEncerrarLimiteContratacaoOperacao(this.model.id, dto).subscribe((data: any) => {
        this.mensagemService.adicionarMensagemSucesso('O limite de contratação foi excluído com sucesso.');
        this.close();
        this.preparaModelo().subscribe((tranche) => {
          this.setModel(tranche);
          this.loadingService.liberaTela();
      });
      });
    }

    public close(): void {
      this.modalService.close();
    }

    public fecharModalFatorRedutor(): void {
      this.close();
      this.formFatorRedutor.reset();
    }

    public fecharModalTaxaStopLoss(): void {
      this.close();
      this.formTaxaStopLoss.reset();
    }

    public fecharModalPrazoContratacao(): void {
      this.close();
      this.formPrazoContratacao.reset();
    }

    public fecharModalLimiteContratacaoBeneficiario(): void {
      this.close();
      this.formLimiteContratacaoBeneficiario.reset();
    }

    public fecharModalLimiteContratacaoOperacao(): void {
      this.close();
      this.formLimiteContratacaoOperacao.reset();
    }

    public fecharModalNovaVigenciaFatorEcg(): void {
      this.close();
      this.formNovaVigenciaFatorEcg.reset();
    }

    public fecharModalNovoFatorRedutorEcg(): void {
      this.close();
      this.formNovoFatorRedutorEcg.reset();
    }

    public fecharModalEncerrarFatorRedutorEcg(): void {
      this.close();
      this.formEncerrarFatorRedutorEcg.reset();
    }

    public fecharModalEncerrarLimiteOperacaoContratacao(): void {
      this.close();
      this.formEncerrarLimiteContratacaoOperacao.reset();
    }

    public fecharModalEncerrarPorteBeneficiario(): void {
      this.close();
      this.formEncerrarPorteBeneficiario.reset();
    }

    public fecharModalVigenciaFatorEcg(): void {
      this.close();
      this.formVigenciaFatorEcg.reset();
      this.formVigenciaFatorEcg = this.createReactiveFormVigenciaFatorEcg();
      this.vigenciaFatorEcg = null;

      if(this.permissaoSalvar) {
        this.permissaoSalvar = false;
        this.buscarVigenciasFatorEcg();
      }
    }

    public fecharModalEventoDistribuicao(): void {
      this.close();
      this.formEventoDistribuicao.reset();
    }

    public fecharModalPorteBeneficiario(): void {
      this.close();
      this.formPorteBeneficario.reset();
    }

    public fecharHistorico(): void {
      this.pesquisado = false;
    }

    public conferirListaEscolhasVazia(listaOpcoesVazia: EventoDistribuicao[], msgError: string): boolean {
        if (!listaOpcoesVazia.length) {
          this.mensagemService.adicionarMensagemAviso(msgError);
          return true;
        }
        return false;
      }

    podeExcluir(dataInicioVigencia: Date, index: number) {
      return (index + 1) === this.vigenciasFatorEcg.length && moment().isBefore(moment(dataInicioVigencia));
    }

    abrirExcluirVigenciaFatorEcg(event, id: number) {
      event.stopPropagation();
      this.idExclusao = id;

      this.modalService.abrir('Confirmação',
      'Está ação irá excluir a linha selecionada.',
      'lg',
      this.msgTemplateExcluir, this.botoesPersonalizadosExcluir);
    }

    abrirExcluirEncerrarLimiteOperacao(event, limite: LimiteContratacaoOperacao, id: number) {
      event.stopPropagation();
      this.idExclusao = id;
      this.dataInicioValidade = limite.dataInicioValidade;

      if(moment(this.dataReferenciaDefault).isAfter(limite.dataInicioValidade)) {
        event.stopPropagation();
        this.formEncerrarLimiteContratacaoOperacao.get('dataInicioValidade').setValue(moment(limite.dataInicioValidade));

        this.modalService.abrir('Confirmação',
          'Está ação irá excluir a linha selecionada.',
          'lg',
        this.msgTemplateEncerrarLimiteContratacaoOperacao, this.botoesPersonalizadosEncerrarLimiteContratacaoOperacao);
      } else {
        this.modalService.abrir('Confirmação',
          'Está ação irá excluir a linha selecionada.',
          'lg',
        this.msgTemplateExcluirLimiteContratacaoOperacao, this.botoesPersonalizadosExcluirLimiteContratacaoOperacao);
      }
    }

    excluirFator(index) {
      const modalRef: NgbModalRef = this.abrirModal.open(ModalConfirmaFatorEcgComponent);

      modalRef.result.then((resultado) => {
        if(resultado.botao === 'sim') {
          this.vigenciaFatorEcg.fatoresEcg.splice(index, 1);

          this.tranchesService.calcularFatores(this.vigenciaFatorEcg.fatoresEcg).subscribe(fatores => this.vigenciaFatorEcg.fatoresEcg = fatores);
        }
      });
    }

    podeExcluirFatorRedutor(fator: FatorReducaoEcg) {
      return moment().isBefore(moment(fator.dataInicioVigencia));
    }

    modalExcluirFatorRedutorEcg(event, id: number) {
      event.stopPropagation();
      this.idExclusao = id;

      this.modalService.abrir('Confirmação',
      'Está ação irá excluir a linha selecionada.',
      'lg',
      this.msgTemplateExcluirFatorRedutor, this.botoesExcluirFatorRedutor);
    }

    excluirFatorRedutorEcg(): void {
      this.loadingService.bloqueiaTela();
      let fatorAnterior: FatorReducaoEcg

      if((this.fatoresReducaoEcg.length - 1) > 0) {
        fatorAnterior = this.fatoresReducaoEcg[this.fatoresReducaoEcg.length - 2];
      }

      this.tranchesService.excluirFatorRedutorEcg(this.idExclusao,  fatorAnterior?.id).toPromise().then(() => {
        this.buscarFatorRedutorEcg();
        this.mensagemService.adicionarMensagemSucesso('O % Redução ECG foi excluído com sucesso.');
      }).catch((err) => {
        this.mensagemService.adicionarMensagemErro('Erro ao excluir o % redução ECG.');
        console.log(err);
      });
      this.close();
      this.loadingService.liberaTela();
    }

    modalEncerrarFatorRedutorEcg(event, fator: FatorReducaoEcg) {
      event.stopPropagation();
      this.fatorEncerramento = fator;
      this.formEncerrarFatorRedutorEcg.get('dataInicioVigencia').setValue(moment(fator.dataInicioVigencia));
      this.formEncerrarFatorRedutorEcg.get('dataFimVigencia').setValue(moment(fator.dataFimVigencia));

      this.formEncerrarFatorRedutorEcg.get('dataInicioVigencia').disable();

      this.modalService.abrir('Encerrar Vigência do %Redução ECG',
      'Está ação irá encerrar a linha selecionada.',
      'lg',
      this.msgTemplateEncerrarFatorRedutor, this.botoesEncerrarFatorRedutor);
    }

    encerrarFatorRedutorEcg(): void {
      this.loadingService.bloqueiaTela();
      this.fatorEncerramento.dataFimVigencia = this.formEncerrarFatorRedutorEcg.get('dataFimVigencia').value;
      this.tranchesService.encerrarVigenciaFatorRedutorEcg(this.fatorEncerramento).toPromise().then(() => {
        this.buscarFatorRedutorEcg();
        this.mensagemService.adicionarMensagemSucesso('O % Redução ECG foi encerrado com sucesso.');
      }).catch((err) => {
        this.mensagemService.adicionarMensagemErro('Erro ao encerrar o % redução ECG.');
        console.log(err);
      });
      this.close();
      this.loadingService.liberaTela();
    }

    encerrarLimiteContratacaoOperacao(): void {
      this.loadingService.bloqueiaTela();
      let dto: any = {};
      dto.id = this.idExclusao;
      dto.dataInicioValidade = this.formEncerrarLimiteContratacaoOperacao.get('dataInicioValidade').value;
      dto.dataFimValidade = this.formEncerrarLimiteContratacaoOperacao.get('dataFimValidade').value;

      if(dto.dataFimValidade == null || dto.dataFimValidade == undefined) {
        this.mensagemService.adicionarMensagemErro('Preencher data final de validade.');
      } else {
        this.tranchesService.excluirEncerrarLimiteContratacaoOperacao(this.model.id, dto).toPromise().then(() => {
          this.mensagemService.adicionarMensagemSucesso('O limite contratação foi encerrado com sucesso.');
          this.preparaModelo().subscribe((tranche) => {
            this.setModel(tranche);
            this.loadingService.liberaTela();
            this.close();
        });
        }).catch((err) => {
          this.mensagemService.adicionarMensagemErro('Erro ao encerrar o limite contratação.');
          console.log(err);
        });
      }
      this.preparaModelo().subscribe((tranche) => {
          this.setModel(tranche);
      });
    }

    podeEncerrarFatorRedutor(fator: FatorReducaoEcg) {
      return fator === this.fatoresReducaoEcg[this.fatoresReducaoEcg.length - 1]
        && moment().isAfter(moment(fator.dataInicioVigencia)) && (moment(fator.dataFimVigencia).isAfter(moment()) || fator.dataFimVigencia == null);
    }

    nomePortePorSigla(sigla: string) {
      const porte = this.siglasPorteBeneficiario.find(p => p.sigla === sigla);
      return porte?.nome;
    }

    public carregaPorteBeneficiarioTranche() {
      let dadosPreenchidos: any = {
       desativados: this.verPortesDesativados,
        pagina: 1,
        limite: 50,
      }

      this.loadingService.bloqueiaTela();
      this.tranchesService
        .buscarPorteBeneficiario(this.model.id,dadosPreenchidos)
          .subscribe((response) => {
            this.porteBeneficiario = response.resultados;
            const valores = response.resultados;
            this.loadingService.liberaTela();
          }, (error) => {
            this.mensagemService.adicionarMensagemErro("Erro ao buscar indexadores.");
            this.loadingService.liberaTela();
          })
    }

    public changeVerPortesDesativados() {
      this.carregaPorteBeneficiarioTranche();
    }

    abrirEncerrarPorteBeneficiario(event, porte: PorteEmpresaClienteTrancheDTO) {
      event.stopPropagation();
      this.idExclusao = porte.id;
      this.dataInicioValidade = porte.dataInicioValidade;

      this.formEncerrarPorteBeneficiario.get('dataInicioValidade').setValue(moment(porte.dataInicioValidade));

      this.modalService.abrir('Encerrar vigência do porte beneficiário',
        'Está ação irá excluir a linha selecionada.',
        'lg',
        this.msgTemplateEncerrarPorteBeneficiario, this.botoesPersonalizadosEncerrarPorteBeneficiario);
    }

    abrirExcluirPorteBeneficiario(event, porte: PorteEmpresaClienteTrancheDTO) {
      event.stopPropagation();
      this.idExclusao = porte.id;
      this.dataInicioValidade = porte.dataInicioValidade;

      this.modalService.abrir('Confirmação',
        'Está ação irá excluir a linha selecionada.',
        'lg',
        this.msgTemplateExcluirPorteBeneficiario, this.botoesPersonalizadosExcluirPorteBeneficiario);
    }

    encerrarPorteBeneficiario(): void {
      this.loadingService.bloqueiaTela();
      let dto: any = {};
      dto.id = this.idExclusao;
      dto.dataInicioValidade = this.formEncerrarPorteBeneficiario.get('dataInicioValidade').value;
      dto.dataFimValidade = this.formEncerrarPorteBeneficiario.get('dataFimValidade').value;

      if(dto.dataFimValidade == null || dto.dataFimValidade == undefined) {
        this.mensagemService.adicionarMensagemErro('Preencher data final de validade.');
      } else {
        this.tranchesService.encerrarPorteBeneficiario(dto.id, dto).toPromise().then(() => {
          this.mensagemService.adicionarMensagemSucesso('O Porte Beneficiário foi encerrado com sucesso.');
          this.loadingService.liberaTela();
          this.carregaPorteBeneficiarioTranche();
        }).catch((err) => {
          this.mensagemService.adicionarMensagemErro('Erro ao encerrar o Porte Beneficiário.');
          console.log(err);
          this.loadingService.liberaTela();
        });
      }
    }

    public excluirPorteBeneficiario(): void {
      this.loadingService.bloqueiaTela();
      this.tranchesService.excluirPorteBeneficiario(this.idExclusao).subscribe((data: any) => {
        this.mensagemService.adicionarMensagemSucesso('O Porte Beneficiário foi excluído com sucesso.');
        this.close();
        this.carregaPorteBeneficiarioTranche();
        this.loadingService.liberaTela();
      }, (error) => {
        console.log(error);
        this.loadingService.liberaTela();
      });
    }

    deveExibirBotaoexcluirPorteBeneficiario(porte: PorteEmpresaClienteTrancheDTO) {
      return (moment(this.dataReferenciaDefault).isBefore(porte.dataFimValidade)
              ||  (porte.dataFimValidade == null || porte.dataFimValidade == undefined));
    }

    exibirExcluirPorte(dataInicioValidade: Date) {
      return moment(this.dataReferenciaDefault).isAfter(dataInicioValidade) || moment(this.dataReferenciaDefault).isSame(dataInicioValidade);
    }

    abrirCiclosMetaDescumprida(): void {
      const options: NgbModalOptions = { size: 'lg', backdrop: 'static', centered: true };
      this.modalRefCiclosMetaDescumprida = this.abrirModal.open(this.modalCiclosMetaDescumprida, options);
    }
}
